import { ToastType } from './types';

export const toastBgStyling: { [key in ToastType]: string } = {
  success: 'bg-J300',
  alert: 'bg-R300',
  info: 'bg-Q300',
  error: 'bg-C300',
};
